import Microapp, { transformPathToUrl } from './micro-app-element';
import init from './init';
import preFetch from './preFetch';

export default Microapp;
export { init, preFetch, transformPathToUrl };
